import React from "react";
import { Col, Container, Row } from "react-bootstrap";
import backgroundImage from "../../../images/location_new/fold2/Bg-uk-andriod.webp";
import { Link } from "gatsby";

function CaseSection(props) {
  return (
    <div
      className="common_section p-100"
      style={{ backgroundImage: `url(${backgroundImage})` }}
    >
      <Container className="h-100">
        <Row className="h-100">
          <Col xs={12} md={12} lg={6} xl={5} xxl={6} className="my-auto">
            <div className="example" data-text="London">
              <h2>Your Go-To Android App Development Company in UK</h2>
            </div>
            <p>
              When it comes to finding Android app developers for hire, look no
              further. We're your go-to choice in the UK for turning your app
              concepts into functional and user-friendly applications. Our team
              of highly skilled professionals is dedicated to delivering
              innovative and custom-made solutions. Partner with us and hire
              Android app developers from our expert team in the UK and make
              your vision a reality.
            </p>
            <Link
              to="/contact"
              className="border_btn dark_btn"
              aria-label="TekRevol Contact"
              target="_blank"
              rel="noopener noreferrer"
            >
              Book A Consultation Now!
            </Link>
          </Col>
        </Row>
      </Container>
    </div>
  );
}

export default CaseSection;
